<script>
import {mapGetters} from 'vuex'
import appConfig from '@src/app.config'
import scrollEvent from '@utils/scroll-animation.js'
import PageHeader from "@components/page-header.vue";
import ModalContainer from "@components/modal-container.vue";
import ModalWindows from "@components/modal-windows.vue";
import Contacts from "@components/contacts.vue";
import MainScreenPagesSection from "@components/sections/main-screen-pages.vue";
import DataPresentationPagesSection from "@components/sections/data-presentation-pages.vue";
import IndustriesSection from "@components/sections/industries.vue";
import ServicesSection from "@components/sections/services.vue";
import HowItWorksSection from "@components/sections/how-it-works.vue";
import InvestmentSection from "@components/sections/investment.vue";
import JustTrySection from "@components/sections/just-try.vue";
import ArticlesSection from "@components/sections/articles.vue";
import QuestionSection from "@components/sections/question.vue";
import FaqSection from "@components/sections/faq.vue";
import DocumentsSection from "@components/sections/documents.vue";
import FullSiteFooter from '@components/full-site-footer.vue'
import CookiesWarning from '@components/elements/cookies-warning.vue'
import Layout from '@layouts/main.vue'
import Loader from "@components/loader.vue";

Number.prototype.lead0 = function (n) {
    var nz = "" + this;
    while (nz.length < n) {
        nz = "0" + nz;
    }
    return nz;
};

export default {
    name: 'Business',
    page: {
        title: appConfig.business.title,
        meta: [{name: 'description', content: appConfig.business.description}],
        link: [{ rel: 'canonical', href: appConfig.business.canonical }]
    },
    components: {
        Loader,
        PageHeader,
        ModalContainer,
        ModalWindows,
        Contacts,
        MainScreenPagesSection,
        DataPresentationPagesSection,
        IndustriesSection,
        ServicesSection,
        HowItWorksSection,
        InvestmentSection,
        JustTrySection,
        ArticlesSection,
        QuestionSection,
        FaqSection,
        DocumentsSection,
        FullSiteFooter,
        CookiesWarning,
        Layout,
    },
    data() {
        return {
            windowsWidth: window.innerWidth,
            topTitle: 'Геоэффект бизнес',
            topText: 'Выбирайте лучшие места для&nbsp;открытия новых точек продаж и&nbsp;развития сети. Сравнивайте и&nbsp;анализируйте трафик и&nbsp;конкурентов',
            slides: [
                '/assets/images/carousels/geo/1.webp',
                '/assets/images/carousels/geo/2.webp',
                '/assets/images/carousels/geo/3.webp',
                '/assets/images/carousels/geo/4.webp',
                '/assets/images/carousels/geo/5.webp',
            ],
            dataPresentationBlocks: [
                '<span>Поиск новых точек</span>',
                '<span>Трафик</span>',
                '<span>Рейтинг локаций</span>',
                '<span>Анализ</span>',
                '<span>Расходы</span>',
            ],
            dataPresentationBlocksAdditional: [
                'Оптимальные локации для открытия бизнеса',
                'Места концентрации целевой аудитории',
                'Индекс торговых точек для управления логистикой и товарооборотом',
                'Конкурентный анализ и исследования',
                'Объемы трат и средние чеки по категориям трат',
            ],
            justTryBlockData: {
                serviceName: 'Оцените возможности Геоэффект бизнес',
                serviceSubtitle: 'с помощью демоверсии',
                imgNum: 3,
                buttonText: 'Перейти к демо',
                buttonTextTranslit: 'pereity_k_demo'
            },
            services: [
                {
                    title: 'Цифровой житель',
                    description: 'Оцените спрос на инфраструктуру с помощью данных о профиле, численности и плотности населения',
                    background: 'tab-map',
                    link: 'citizen',
                },
                {
                    title: 'Цифровой туризм',
                    description: 'Повышайте потенциал туристической отрасли, анализируя турпоток в регионе',
                    background: 'tab-tourism',
                    link: 'tourist',
                },
                {
                    title: 'Посещаемость',
                    description: 'Анализ событий и мероприятий, исследуйте посещаемость объектов и территорий, отслеживайте динамику изменений',
                    background: 'tab-visiting',
                    link: 'visiting',
                },
            ],
            mobileNavigationBg: false,
            headerLinks: [
                {
                    text: 'Цифровой житель',
                    external: false,
                    link: 'citizen',
                    analyticsLabel: 'cifrovoi_zhitel',
                },
                {
                    text: 'Цифровой туризм',
                    external: false,
                    link: 'tourist',
                    analyticsLabel: 'cifrovoi_turizm',
                },
                {
                    text: 'Посещаемость',
                    external: false,
                    link: 'visiting',
                    analyticsLabel: 'poseschaemost',
                },
                {
                    text: 'Геоэффект бизнес',
                    external: false,
                    link: 'business',
                    analyticsLabel: 'geoeffekt_biznes',
                },
                {
                    text: 'Документация',
                    external: false,
                    link: null,
                    analyticsLabel: 'dokumentaciya',
                },
            ],
        }
    },
    created() {
        window.addEventListener("scroll", scrollEvent);
        window.addEventListener('resize', this.onResize);
    },
    beforeDestroy() {
        window.addEventListener('resize', this.onResize);
        document.body.style.overflow = 'visible';
    },
    computed: {
        ...mapGetters({
            getActiveModalWindow: 'modal/getActiveModalWindow',
        }),
        isMobile() {
            return this.windowsWidth <= 1000;
        }
    },
    methods: {
        onResize() {
            this.windowsWidth = window.innerWidth;
        },
    },
}
</script>

<template>
    <Layout class="landing-page">
        <Loader />

        <PageHeader
            :links="headerLinks"
            :logo-link="false"
            :is-mobile="isMobile"
            :show-login-button="true"
        />

<!--        <ModalContainer />-->

        <ModalWindows
            :open-window="getActiveModalWindow"
        />

        <Contacts />

        <div id="main-page" class="city-map">
            <MainScreenPagesSection
                :title="topTitle"
                :text="topText"
                :button-text="'Попробовать демо'"
                :button-text-translit="'poprobovat_demo'"
                :button-link-to-geoeffect="true"
                :is-mobile="isMobile"
                :slides="slides"
            />

            <DataPresentationPagesSection
                :blocks="dataPresentationBlocks"
                :additional-text="dataPresentationBlocksAdditional"
                :block-minimal-width-tablet="212"
                :small-title="true"
            />
        </div>

        <IndustriesSection />

        <ServicesSection :services="services" />

        <HowItWorksSection />

<!--        <InvestmentSection />-->

        <JustTrySection
            :service-name="justTryBlockData.serviceName"
            :service-subtitle="justTryBlockData.serviceSubtitle"
            :button-text="justTryBlockData.buttonText"
            :button-text-translit="justTryBlockData.buttonTextTranslit"
            :img-num="justTryBlockData.imgNum"
            :is-mobile="isMobile"
            :button-link-to-geoeffect="true"
        />

        <ArticlesSection />

        <QuestionSection />

        <FaqSection />

        <DocumentsSection />

        <CookiesWarning />
    </Layout>
</template>

<style lang="scss">
    @import '@design/components/header.scss';
    @import '@design/components/full-site-footer.scss';
    @import '@design/landing.scss';
</style>

